import React from "react";
import { useLeftNavPlaceholderStyles } from "./LeftNavPlaceholder.styles";
/** A styled wrapper for placeholder content while the LeftNav is loading */ export const LeftNavPlaceholder = ({ children })=>{
    const styles = useLeftNavPlaceholderStyles();
    return /*#__PURE__*/ React.createElement("div", {
        className: styles.root
    }, children);
};
